import { IModelEntity } from '@pit/core';
import { IDtoResourceCheckItem } from './dto.resource.check.item.interface';
import { IDtoUser } from './dto.user.interface';
import { IDtoResource } from './dto.resource.interface';
import { IDtoMandator } from './dto.mandator.interface';

export interface IDtoResourceCheck extends IModelEntity {

    checkResult?: number;
    timestamp?: Date;

    deviceId?: string;
    resourceCode?: string;
    resourceId?: string;
    resourceTypeCode?: string;
    resourceTypeDescription?: string;
    userName?: string;
    userNumber?: string;

    mandator?: IDtoMandator;

    items?: IDtoResourceCheckItem[];

    getHasFaults?: () => boolean;

}
